import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import NavigationTab from '../Tab/NavigationTab.jsx';
import { navigateTo, TAB, TAB_CONFIG } from './menuConfig';
import { getGeoData, getPageViewId, getRealEstateType } from '../../../selectors/selectors.js';
import tracking from '../../../tracking/tracking.js';
import navigationActions from '../actions.js';
import styles from '../Navigation.less';
import parseGeoInfo from '../../../utils/trackingGeoData';

export const NavigationMenu = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClickHandler = (tab) => {
    const { foldSidebar, closeBurgerMenu, trackingGeoInfo, pageTitle } = props;
    foldSidebar();
    closeBurgerMenu();
    tracking.reportData({
      label: TAB[tab.id].trackingLabel,
      pag_pagetitle: pageTitle,
      geo_land: trackingGeoInfo.country,
      geo_bln: trackingGeoInfo.region,
      geo_krs: trackingGeoInfo.city,
      geo_plz: trackingGeoInfo.zipcode,
    });
    navigateTo(navigate, tab);
  };

  const renderTab = (tab) => {
    const { collapsed } = props;
    const onClickHandlerForNavigation = () => onClickHandler(tab);

    return (
      <NavigationTab
        key={`tab_${tab.id}`}
        dataIdentifier={tab.dataIdentifier}
        tab={tab}
        active={tab.isActive(location.pathname)}
        onClick={onClickHandlerForNavigation}
        collapsed={collapsed}
        tooltip={false}
        isSidebarDesktopExpanded={!collapsed}
      />
    );
  };

  const { collapsed } = props;
  return (
    <div className="grid-item">
      <ul data-qa="nav_menu" className={`${styles.nav_menu} ${collapsed ? styles.collapsed : ''}`}>
        {TAB_CONFIG.map((tab) => renderTab(tab))}
      </ul>
    </div>
  );
};

NavigationMenu.defaultProps = {
  collapsed: false,
};

NavigationMenu.propTypes = {
  collapsed: PropTypes.bool,
  foldSidebar: PropTypes.func.isRequired,
  closeBurgerMenu: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    pageTitle: getPageViewId(state),
    realEstateType: getRealEstateType(state),
    trackingGeoInfo: parseGeoInfo(getGeoData(state)),
    isLoggedIn: get(state, ['auth', 'isLoggedIn'], false),
  };
};

const mapDispatchToProps = (dispatch) => ({
  foldSidebar: () => dispatch(navigationActions.toggleSidebar(false)),
  closeBurgerMenu: () => dispatch(navigationActions.closeBurgerMenu(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationMenu);
